import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { railwayCardMotion } from './motion';
import { railwayChromeTone } from './palette';

export const railwayTheme: FlowThemeDefinition = {
  id: 'railway',
  label: 'Railway',
  description: 'A little steam train chuffs from station to station through storybook countryside, arriving at the seaside at sunset.',
  category: 'playful',
  chromeTone: railwayChromeTone,
  swatch: 'linear-gradient(160deg, #6FB2EA 0%, #FFD98E 45%, #8DC75E 70%, #C9392B 100%)',
  cardGlass: 'default',
  cardMotion: railwayCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createRailwayScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
